import React from 'react'
import { motion } from 'framer-motion'
import {
  animationAppTransitions,
  animationAppVariants
} from '../../component/Helpers/pageAnimation'
import ProceduresList from '../../component/Config/Procedures/ProceduresList'

const Budgets: React.FC = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={animationAppVariants}
      transition={animationAppTransitions}
    >
      <ProceduresList />
    </motion.div>
  )
}

export default Budgets
